// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_wrapper__QlfXb","loading":"loading_loading__+cQGD"};